/** @format */

import { useCallback, useEffect, useState } from "react";
import { Brand, ImportJob } from "@question-bank/shared";
import { listImports } from "../api/imports";

interface UseImportJobsReturn {
	jobs: ImportJob[];
	isLoading: boolean;
	error: string | null;
	reload: () => void;
}

/**
 * Loads the CSV import history for a brand
 *
 */
export const useImportJobs = (brand: Brand): UseImportJobsReturn => {
	const [jobs, setJobs] = useState<ImportJob[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [reloadToken, setReloadToken] = useState(0);

	const reload = useCallback(() => setReloadToken((token) => token + 1), []);

	useEffect(() => {
		let isCancelled = false;
		setIsLoading(true);
		setError(null);

		listImports(brand)
			.then((result) => {
				if (!isCancelled) {
					setJobs(result);
				}
			})
			.catch((err) => {
				if (!isCancelled) {
					setError(err instanceof Error ? err.message : "failed to load import jobs");
				}
			})
			.finally(() => {
				if (!isCancelled) {
					setIsLoading(false);
				}
			});
		return () => {
			isCancelled = true;
		};
	}, [brand, reloadToken]);
	return { jobs, isLoading, error, reload };
};
